export default ({
  namespaced: true,
  state: {
    view: 'dialogBeta',
    // file: nome do arquivo que estará na pasta beta do produção
    values: {title: '', text: '', customText: '', file: '', showDialog: false}
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      // caso não tenha sido passado o btnClose, passa ele como false
      Object.assign(state.values, {title: 'Temos novidades...'}, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/dialogBeta.js